import { setStagehall, setSales, setDonationsOn, setPreSalesEnabled } from '../../redux/app-redux';

export default { setStagehall, setSales, setDonationsOn, setPreSalesEnabled };
